export default "__VITE_ASSET__CCKekw8L__"